import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TextoLinkComponent } from '../../shared/componentes/texto-link/texto-link.component';
import { Util } from '../../shared/Util';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'box-info-truck-crossdocking',
  templateUrl: './box-info-truck-crossdocking.component.html',
  styleUrl: './box-info-truck-crossdocking.component.css',
  standalone: true,
  imports: [TextoLinkComponent, DatePipe, CurrencyPipe],
})
export class BoxInfoTruckCrossdockingComponent{
  @Input() dados:any;
  @Input() tempoEstimado:any;
  @Input() versaoApp:any;
  @Output() editar = new EventEmitter();
  infoRota: any = null;
  roteirosNumeros = ''
  nomeAjudantePrimeiro: String | null = null;
  nomeAjudanteSegundo: String | null = null;

  constructor(public util: Util) { }

  ngOnChanges() {
    this.infoRota = JSON.parse(this.dados.InfoRota);
    const numeros = this.dados.roteirosCrossdocking.map((d: any) => d.numeroRoteiroFilho);

    this.roteirosNumeros =
      numeros.length > 1
        ? numeros.slice(0, -1).join(', ') + ' e ' + numeros[numeros.length - 1]
        : numeros[0] || '';
    this.verificaContemAjudantes();
  }

  toggleEdicao(){
    this.editar.emit();
  }

  verificaContemAjudantes(){
    this.nomeAjudantePrimeiro = null;
    this.nomeAjudanteSegundo = null;
    if(this.infoRota.Ajudante != null){
      const ajudantes = this.infoRota.Ajudante
      if(ajudantes.length > 0){
        this.nomeAjudantePrimeiro = ajudantes[0].nome;
      }
      if(ajudantes.length > 1){
        this.nomeAjudanteSegundo = ajudantes[1].nome;
      }
    }
  }
}
